<template lang="html">
  <step
    :complete='complete'
    :step='step'
    :icon='icon'
    :title='title'>
    <v-form
      @submit.prevent='validate'
      class='ml-1'
      :value='value'
      @input="$emit('input', $event)"
      lazy-validation
      ref="form">
      <v-container class='form-container'>
        <slot>
          <v-text-field label='Default Input' disabled/>
        </slot>
      </v-container>
    </v-form>
  </step>
</template>

<script>
import Step from './Step'
export default {
  components: {
    step: Step
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [Number, String],
      default: 1
    },
    icon: {
      type: String,
      default: 'mdi-alert'
    },
    title: {
      type: String,
      default: 'Empty Form Step'
    }
  },
  methods: {
    validate () {
      if (this.$refs.form.validate()) {
        this.$emit('submit')
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
